import { render, staticRenderFns } from "./Yahoo.vue?vue&type=template&id=6740cc1a&"
import script from "./Yahoo.vue?vue&type=script&lang=js&"
export * from "./Yahoo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports